import { truePrice } from "@/assets/js/util";

export let currencies = [
    { id: 'EUR', name: 'Euro', convert: 1.1, sign: 2, symbol: '€' },
    { id: 'THB', name: 'Thai Bhat', convert: 1, sign: 0, symbol: '฿' },
    { id: 'USD', name: 'US Dollar', convert: 1, sign: 2, symbol: '$' },
]

export let routesAdmin = [
    { route: "/admin", name: "Overview", icon: "material-symbols:overview" },
    { route: "/admin/calendar", name: "Calendar", icon: "material-symbols:calendar-month" },
    { route: "/admin/team", name: "Team", icon: "material-symbols:group" },
    { route: "/admin/strains/view", name: "Strains", icon: "akar-icons:jar" },
    { route: "/admin/inventory/view", name: "Inventory", icon: "material-symbols:inventory" },
    { route: "/admin/sales/view", name: "Sales", icon: "material-symbols-light:point-of-sale" },
    { route: "/admin/customers/view", name: "Customers", icon: "carbon:customer" },
    { route: "/admin/analytics", name: "Website", icon: "solar:chart-2-outline" },
    { route: "/admin/suppliers/view", name: "Suppliers", icon: "material-symbols:man" },
    { route: "/admin/expenses/view", name: "Expenses", icon: "icon-park-outline:expenses" },
    { route: "/admin/certificate", name: "Certificate", icon: "solar:document-medicine-outline" },
    { route: "/admin/age-verifications", name: "Age Checks", icon: "solar:shield-check-outline" },
    { route: "/admin/whatsapp", name: "WhatsApp", icon: "ic:baseline-whatsapp" },
    { route: "/admin/cctv", name: "POS CCTV", icon: "material-symbols:screen-record" },
];

export let routes = [
    { route: "https://wa.me/qr/MFLG4COX3DU6D1", name: "Whatsapp", icon: "ic:baseline-whatsapp" },
    { route: "https://lin.ee/9NP6680", name: "Line", icon: "mingcute:line-app-line" },
    { route: "https://www.instagram.com/junglehouse.phuket", name: "Instagram", icon: "mdi:instagram" },
    { route: "https://maps.app.goo.gl/TaBNoCJ9ub3JmFrs8", name: "Google Maps", icon: "simple-icons:googlemaps" },
    { route: "https://www.facebook.com/profile.php?id=61553376604235", name: "Facebook", icon: "ic:baseline-facebook" },
];

export let routesPOS = [
    { route: "/pos", name: "POS", icon: "mdi:printer-pos-outline" },
    { route: "/printer", name: "Label", icon: "ic:outline-label" },
    { route: "/shifts", name: "Shifts", icon: "fluent:shifts-activity-20-regular" },
    { route: "/sale-history", name: "Sale History", icon: "solar:history-outline" },
    { route: "/unpaid-orders", name: "Unpaid Orders", icon: "mdi:clock-alert-outline" },
    { route: "/pending-orders", name: "Pending Orders", icon: "mdi:cart-arrow-down" },
    { route: "/members", name: "Members", icon: "tdesign:member" },
    { route: "/inventory", name: "Add or Restock Inventory", icon: "material-symbols:inventory" },
    { route: "/restock", name: "Add or Restock Flower", icon: "material-symbols:spa" },
    { route: "/restock-list", name: "Restock List", icon: "mdi:barcode-scan" },
    { route: "/pos-settings", name: "Settings", icon: "mdi:cog-outline" },
];

export const hubAccessPin = "2402";

export let themes = [
    { id: 'dark', name: 'Dark' },
    { id: 'light', name: 'Light' },
]

export let timeFrames = [
    { id: 'off', name: 'Off' },
    { id: '4#week', name: '4 Weeks' },
    { id: '1#week', name: '1 Week' },
    { id: '1#day', name: '1 Day' },
    { id: '8#hour', name: '8 Hours' },
    { id: '1#hour', name: '1 Hours' },
    { id: '5#minute', name: '5 Minutes' },
    { id: '1#minute', name: '1 Minute' },
]

export let commerceSort = [
    { label: "Best Sellers", value: "-salesScore" },
    { label: "Most Recent", value: "-created" },
    { label: "Name A - Z", value: "+strain" },
    { label: "Name Z - A", value: "-strain" },
    { label: "Price Low to High", value: "+customerPrice" },
    { label: "Price High to Low", value: "-customerPrice" },
];

export let inventorySort = [
    { label: "Best Sellers", value: "-salesScore" },
    { label: "Most Recent", value: "-created" },
    { label: "Name A - Z", value: "+name" },
    { label: "Name Z - A", value: "-name" },
    { label: "Price Low to High", value: "+price" },
    { label: "Price High to Low", value: "-price" },
];


export let deliveryMethod = {
    instant: { label: "Instant Delivery", value: "instant", hint: 'Next day delivery. Thai Post' },
    ems: { label: "EMS Delivery", value: "ems", hint: '60 Minute Delivery. GRAB, inDriver' },
};


export let paymentMethod = {
    bank: { label: "Bank Transfer", value: "bank" },
    cod: { label: "Cash on Delivery", value: "cod" },
};



export let strainTypes = [
    { label: "Sativa", icon: "ph:sun" },
    { label: "Hybrid", icon: "ph:cloud-sun" },
    { label: "Indica", icon: "ph:moon" },
];

// Jungle House smell categories. A strain gets a main smell plus any number of
// secondary smells (first = main). Tag what the jar smells like, not the strain guide.
export const strainSmellOptions = ["Gassy", "Fruity", "Dessert", "Funky", "Earthy", "Herbal"];

export const strainSmellHints = {
    Gassy: "Diesel, fuel, chem, solvent, sour diesel",
    Fruity: "Berry, grape, tropical, citrus, lemon",
    Dessert: "Cake, cream, cookie, candy, vanilla",
    Funky: "Garlic, onion, cheese, skunk",
    Earthy: "Soil, wood, hash, kush, pepper, spice",
    Herbal: "Pine, haze, mint, lavender, floral",
};

export const STRAIN_SMELL_MAX = strainSmellOptions.length;

// Storefront icon + tap-to-explain copy for each smell family (mirrors the printed Smell Guide).
export const strainSmellInfo = {
    Gassy: {
        icon: "ph:gas-can",
        blurb: "Sharp, pungent and loud. Diesel and chemical notes that fill the room the moment the jar opens.",
        notes: ["Diesel", "Fuel", "Chem", "Sour Diesel"],
        examples: ["OG Kush", "Sour Diesel"],
    },
    Fruity: {
        icon: "lucide:cherry",
        blurb: "Bright and juicy, often driven by limonene. Berries, tropical fruit and fresh citrus peel.",
        notes: ["Berry", "Tropical", "Grape", "Citrus", "Lemon"],
        examples: ["Zkittlez", "Tangie"],
    },
    Dessert: {
        icon: "ph:cake",
        blurb: "Sweet and creamy, like a bakery counter. Cake batter, vanilla, cookies and candy.",
        notes: ["Cake", "Cream", "Cookie", "Candy", "Vanilla"],
        examples: ["Gelato", "Wedding Cake"],
    },
    Funky: {
        icon: "ph:cheese",
        blurb: "Savoury and bold. Garlic, cheese and old-school skunk. Not for everyone, loved by those who get it.",
        notes: ["Garlic", "Cheese", "Onion", "Skunk"],
        examples: ["GMO", "UK Cheese"],
    },
    Earthy: {
        icon: "ph:mountains",
        blurb: "Deep and grounding. Damp soil, wood and hash, with a peppery bite from caryophyllene. The classic kush smell.",
        notes: ["Soil", "Wood", "Hash", "Kush", "Spice"],
        examples: ["Bubba Kush", "Afghani"],
    },
    Herbal: {
        icon: "ph:tree-evergreen",
        blurb: "Fresh and green rather than sweet. Pine forest (pinene), haze, mint and lavender.",
        notes: ["Pine", "Haze", "Mint", "Floral", "Incense"],
        examples: ["Jack Herer", "Amnesia Haze"],
    },
};

export let sortMapping = {
    "+strain": (a, b) => a.strain?.localeCompare(b.strain) || 0,
    "-strain": (a, b) => b.strain?.localeCompare(a.strain) || 0,
    "-created": (a, b) => b.created.localeCompare(a.created),
    "+customerPrice": (a, b) => truePrice(a.customerPrice, 1, a.discount) - truePrice(b.customerPrice, 1, b.discount),
    "-customerPrice": (a, b) => truePrice(b.customerPrice, 1, b.discount) - truePrice(a.customerPrice, 1, a.discount),
    "+name": (a, b) => (a.name || '').localeCompare(b.name || ''),
    "-name": (a, b) => (b.name || '').localeCompare(a.name || ''),
    "+price": (a, b) => (a.price || 0) - (b.price || 0),
    "-price": (a, b) => (b.price || 0) - (a.price || 0),
    "+stock": (a, b) => (a.stock || 0) - (b.stock || 0),
    "-stock": (a, b) => (b.stock || 0) - (a.stock || 0),
};

export let discounts = [
    { percent: 1, grams: 1, font: 32, gap: 3 },
    { percent: 0.95, grams: 3, font: 14, gap: 15 },
    { percent: 0.9, grams: 5, font: 14, gap: 15 },
    { percent: 0.85, grams: 7, font: 14, gap: 15 },
    { percent: 0.8, grams: 14, font: 14, gap: 15 },
    { percent: 0.7, grams: 28, font: 14, gap: 15 },
    { percent: 0.5, grams: 50, font: 14, gap: 15 },
    { percent: 0.4, grams: 100, font: 14, gap: 15 }
];

// Flower bundle rules (POS + shop cart). Shown read-only on POS Settings →
// Pricing rules until they move into tenant settings.
export const BUNDLE_PRICE_RANGE = 50;      // strains within ฿50/g of the cheapest in a group bundle together
export const BUNDLE_MIN_GRAMS = 3;         // a group under this many grams gets no bundle discount
export const PREROLL_BUNDLE_MAX_GRAMS = 5; // prerolls add at most this many grams to a bundle (caps them at the 5g / 10% tier)
export const ROLLING_SERVICE_FEE = 50;     // flat ฿ added to a line when staff roll it for the customer

export let wholesaleDiscounts = [
    { percent: 0.8, grams: 14, font: 14, gap: 15 },
];

export let shiftTeams = [
    { label: "Lalyn", value: "sebLalyn" },
    { label: "Staff", value: "staff" },
];


export let cartSteps = ["Cart", "Checkout", "Payment", "Confirmation"];

export let strain = {
    strain: "",
    breeder: "",
    stock: 0,
    supplierPrice: 0,
    supplier: "",
    img: "",
    imgSm: "",
    image: null,
    barcode: "0000000",
    customerPrice: 0,
    description: "",
    thc: "",
    taste: "",
    smell: [],
    type: "",
    parents: "",
    discount: 0
};

export let inventory = {
    date: "",
    name: "",
    catalog: "",
    stock: 1,
    price: 0,
    cost: 0,
    img: "",
    imgSm: "",
    image: null,
    barcode: "0000000",
};

export let shift = {
    startDateTime: null,
    createdAt: null,
    updatedAt: null,
    endDateTime: null,
    actualCash: 0,
    startingCash: 2000,
    finishingCash: 0,
    customers: 0,
    total: 0,
    totalAfterDiscounts: 0,
    qr: 0,
    cash: 0,
    team: { label: "", value: "" }
};


